import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    width: 100%;
    padding: 6px 8px;
    color: ${theme?.colour?.secondary};
    background: ${displayState?.selected ? `${theme?.colour?.primary}0D` : ''};

    cursor: pointer;

    &:hover {
      background: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template: template })